@if (!standalone) {
  <kb-control-hint
    [showError]="showError"
    #controlContainerElement
  >
    <ng-content select="kb-hint" ngProjectAs="kb-hint"></ng-content>
    <ng-content select="kb-error" ngProjectAs="kb-error"></ng-content>
  </kb-control-hint>
  <ng-container *ngTemplateOutlet="inputTemplate; context: {controlContainerElement:controlContainerElement}"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="inputTemplate; context: {controlContainerElement:null}"></ng-container>
}

<ng-template #inputTemplate let-controlContainerElement="controlContainerElement">
  <input
    [id]="controlId"
    kbCheckboxControlValueAccessor
    [attr.aria-describedby]="controlContainerElement ? controlContainerElement.hintElement?.id : null"
    type="checkbox"
    [attr.required]="required ? '' : null"
    [tabindex]="tabindex"
    #input
  >
  <label [for]="controlId">
    <ng-content></ng-content> {{required && showRequired ? ' *' : ''}}
  </label>
</ng-template>
